import type { ReactNode } from 'react';
import { cn } from '@shared/utils';
import { Button, NoData, Spinner } from '@shared/widgets';

interface ViewProps {
  className?: string;
  loadingClassName?: string;
  errorClassName?: string;
  noDataClassName?: string;
  loading?: boolean;
  error?: string | null;
  onRefresh?: () => void;
  noData?: boolean;
  noDataText?: string;
  children?: ReactNode;
}

export const View = (props: ViewProps) => {
  if (props.loading) return <Spinner className={cn(props.className, props.loadingClassName)} />;
  if (props.error)
    return (
      <div className={cn('flex flex-col items-center gap-4', props.className, props.errorClassName)}>
        <NoData className={cn('p-0')} text={props.error} />
        {props.onRefresh && (
          <Button color='primary' onClick={props.onRefresh}>
            Refresh
          </Button>
        )}
      </div>
    );
  if (props.noData) return <NoData className={cn('p-0', props.className, props.noDataClassName)} text={props.noDataText} />;
  return props.children;
};
